{
  "rsi": {
    "twitterAccount": "RSIonline"
  },
  "rtr": {
    "twitterAccount": "RTRSRG"
  },
  "rts": {
    "twitterAccount": "RadioTeleSuisse"
  },
  "srf": {
    "twitterAccount": "SRF"
  },
  "swi": {
    "twitterAccount": "swissinfo"
  }
}
